import React from "react";
import styles from "../Dashoard.module.css";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const Overview = (props) => {
  const { allCoursesSalesInfo, allCoursesEnrollmentInfo } = props;

  return (
    <div className={styles.StatusSection}>
      <div className={styles.StatusSectionHeader}>
        <h2>Overview</h2>
      </div>

      <div className={styles.StatusSectionInner}>
        <div className={styles.StatusCard}>
          <div className={styles.StatusCardTitle}>Sales</div>
          <div className={styles.StatusCardAmount}>
            ${allCoursesSalesInfo?.totalSale}
          </div>
          {allCoursesSalesInfo?.percentageDifference > 0 && (
            <div className={styles.StatusCardChip}>
              <span
                className={
                  allCoursesSalesInfo?.isUpOrDown == "down"
                    ? styles.StatusCardChipRed
                    : styles.StatusCardChipGreen
                }
              >
                {allCoursesSalesInfo?.isUpOrDown == "down" ? (
                  <ArrowDownwardIcon />
                ) : (
                  <ArrowUpwardIcon />
                )}
                {allCoursesSalesInfo?.percentageDifference
                  ? parseInt(allCoursesSalesInfo?.percentageDifference)
                  : 0}
                %
              </span>
            </div>
          )}
        </div>

        <div className={styles.SP_line}></div>

        <div className={styles.StatusCard}>
          <div className={styles.StatusCardTitle}>Enrollment</div>
          <div className={styles.StatusCardAmount}>
            {allCoursesEnrollmentInfo?.totalEnrollments
              ? allCoursesEnrollmentInfo.totalEnrollments
              : 0}
          </div>
          {allCoursesEnrollmentInfo?.percentageDifference >= 0 && (
            <div className={styles.StatusCardChip}>
              <span
                className={
                  allCoursesEnrollmentInfo?.isUpOrDown == "down"
                    ? styles.StatusCardChipRed
                    : styles.StatusCardChipGreen
                }
              >
                {allCoursesEnrollmentInfo?.isUpOrDown == "down" ? (
                  <ArrowDownwardIcon />
                ) : (
                  <ArrowUpwardIcon />
                )}
                {allCoursesEnrollmentInfo?.percentageDifference
                  ? parseInt(allCoursesEnrollmentInfo?.percentageDifference)
                  : 0}
                %
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Overview;
